import { ProductDimension } from '@msdyn365-commerce/retail-proxy';
import { DIMENSION_TYPE_VALUES } from '../const/dimensionTypeValues';

export const getVariantDimensionValue = (
    dimensions: ProductDimension[] | undefined,
    dimensionToFind: keyof typeof DIMENSION_TYPE_VALUES
) => {
    return dimensions?.find(dimension => dimension.DimensionTypeValue === DIMENSION_TYPE_VALUES[dimensionToFind])?.DimensionValue?.Value;
};
